import React from 'react';
import { useRouteError } from 'react-router-dom'

const PageNotFoundContent = () => {
    const error = useRouteError()
    console.error(error)
    return (
        <div className='flex flex-col text-center items-center'>
            <div className="text-2xl font-bold my-2">Oops!</div>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
        </div>
    );
}

export default PageNotFoundContent;
